package com.milta.core.appconfig

import com.milta.core.network.ApiException
import com.milta.core.network.Endpoints
import com.milta.core.network.baseUrl
import com.milta.feature.auth.data.remote.dto.ApiError
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.statement.HttpResponse
import io.ktor.http.isSuccess

/**
 * GET /api/v1/app-config — authenticated, any role. Currently exposes only [AppConfigResponse.routarEnabled],
 * the RoutaR (route optimization engine) kill switch: when `false`, every optimization endpoint
 * already returns 409/503 `error.optimization_unavailable` (pre-existing behavior), so this flag is
 * only consulted client-side to proactively hide the optimize/re-optimize CTAs instead of letting
 * the user hit that failure every time.
 */
class AppConfigApi(private val client: HttpClient) {

    suspend fun getAppConfig(): AppConfigResponse =
        client.get("$baseUrl/${Endpoints.appConfig}").decodeOrThrow()

    private suspend inline fun <reified T> HttpResponse.decodeOrThrow(): T {
        if (!status.isSuccess()) {
            val apiError = runCatching { body<ApiError>() }.getOrNull()
            val message = apiError?.code ?: "error_${status.value}"
            throw ApiException(status.value, message)
        }
        return body()
    }
}
